import { useMemo } from 'react';

import { useTimeId } from 'Stores/BidCountSortStore/BidCountSortStore';
import { useListType } from 'Stores/ListStore/ListStore';
import type { FilterQuery } from 'Types/filter';
import { LIST_TYPES } from 'Utilities/consts';

import useSortOrder from '../useSortOrder/useSortOrder';

export interface UseVehicleListQueryParams {
	recommendedSortOrderVersion?: Nullable<string>;
	serverQuery?: FilterQuery['serverQuery'];
	shouldIncludeRecommendedSortOrderVersion?: boolean;
}

export interface UseVehicleListQuery {
	filterQuery?: FilterQuery['serverQuery'];
	order?: string;
	sort?: string;
	timeId?: number;
}

const useVehicleListQuery = ({
	recommendedSortOrderVersion,
	serverQuery,
	shouldIncludeRecommendedSortOrderVersion = false,
}: UseVehicleListQueryParams): UseVehicleListQuery => {
	const timeId = useTimeId();
	const listType = useListType();
	const { defaultOrder, defaultSort, order, sort } = useSortOrder();

	const shouldIncludeTimeId = listType === LIST_TYPES.auction && timeId;

	const vehicleListQuery = useMemo(() => {
		const sortOrderQuery = {
			...(defaultSort === sort && { sort }),
			...(defaultOrder === order && { order }),
		};

		return {
			...sortOrderQuery,
			...(serverQuery && { filterQuery: serverQuery }),
			...(shouldIncludeTimeId && { timeId }),
			...(shouldIncludeRecommendedSortOrderVersion && { recommendedSortOrderVersion }),
		};
	}, [
		serverQuery,
		order,
		sort,
		defaultSort,
		defaultOrder,
		shouldIncludeTimeId,
		timeId,
		recommendedSortOrderVersion,
		shouldIncludeRecommendedSortOrderVersion,
	]);

	return vehicleListQuery;
};

export default useVehicleListQuery;
